import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Building2, Scale, ArrowRight } from 'lucide-react';
interface LegalAuthoritySectionProps {
  onOpenForm: () => void;
}
export function LegalAuthoritySection({
  onOpenForm
}: LegalAuthoritySectionProps) {
  const authorities = [{
    icon: <Shield className="w-8 h-8 text-navy" data-id="element-297" />,
    title: 'FCRA §1681i — Your Right to Dispute',
    body: 'Federal law gives consumers the right to dispute inaccurate or incomplete reporting and requires bureaus to conduct reasonable reinvestigations within legally defined timelines.',
    footer: 'FCRA § 611',
    link: '#'
  }, {
    icon: <Building2 className="w-8 h-8 text-navy" data-id="element-298" />,
    title: 'CFPB Complaint Oversight',
    body: 'The Consumer Financial Protection Bureau collects, publishes, and monitors complaint patterns involving consumer reporting agencies, furnishers, and financial institutions nationwide.',
    footer: 'consumerfinance.gov',
    link: '#'
  }, {
    icon: <Scale className="w-8 h-8 text-navy" data-id="element-299" />,
    title: 'FTC Enforcement Actions',
    body: 'The Federal Trade Commission pursues deceptive marketing and unlawful conduct involving consumer financial products, including misleading credit-related advertising and fee structures.',
    footer: 'ftc.gov',
    link: '#'
  }];
  return <section className="py-24 lg:py-36 bg-white" data-id="element-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-301">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-302">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center px-3 py-1.5 rounded-full bg-navy/5 border border-navy/10 mb-6" data-id="element-303">
            <span className="text-navy text-xs font-bold tracking-widest uppercase" data-id="element-304">
              Federal Oversight
            </span>
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-3xl md:text-4xl lg:text-5xl font-bold font-serif text-navy mb-6 tracking-tight" data-id="element-305">
            You Have Legal Rights. Most People Don't Know Them.
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-306">
          {authorities.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-xl p-8 border border-slate-200 flex flex-col h-full shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300" data-id="element-307">
              <div className="mb-6" data-id="element-308">{item.icon}</div>
              <h3 className="text-xl font-bold text-navy mb-4" data-id="element-309">{item.title}</h3>
              <p className="text-slate leading-[1.75] mb-8 flex-grow" data-id="element-310">
                {item.body}
              </p>
              <div className="pt-6 border-t border-slate-100 mt-auto" data-id="element-311">
                <a href={item.link} className="text-xs font-mono text-slate-500 hover:text-slate-800 underline underline-offset-4 transition-colors" data-id="element-312">
                  {item.footer}
                </a>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-313">
          <motion.button initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} onClick={onOpenForm} className="inline-flex items-center justify-center bg-emerald hover:bg-emerald-600 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all duration-200 shadow-cta hover:shadow-lg transform hover:-translate-y-0.5" data-id="element-314">
            Get the Free FCRA Dispute Guide
            <ArrowRight className="ml-2 w-5 h-5" data-id="element-315" />
          </motion.button>
        </div>
      </div>
    </section>;
}